export enum RouteEnums {
    DASHBOARD = "home",
    LOGIN = "login",
  }
  